import {connect} from 'react-redux';
import Search from 'educator/app/components/students/table/search';
import {fetchSearchResults, updateQuery} from 'educator/actions/students';

const mapStateToProps = ({studentSearchOptions: {query, sortField}, educator}) => ({
  query,
  sortField,
  educator,
});

const mapDispatchToProps = (dispatch) => ({
  fetchStudents: (query) => dispatch(fetchSearchResults({query, page: 1})),
  updateQuery: (query) => dispatch(updateQuery(query)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Search);
